// Zitierter Verlauf im Entwurf: Der Server legt ihn als <div class="mm-quote">…</div> ans Ende des
// Entwurfs. Der Editor bekommt nur den eigenen Teil (Text + Signatur), das Zitat bleibt als Block
// darunter eingeklappt und wird beim Speichern/Senden unverändert wieder angehängt. So bleibt das
// Original-HTML der zitierten Mail erhalten (TipTap würde Tabellen, Bilder und den Rahmen wegwerfen).

const QUOTE_DIV = '<div class="mm-quote"';
// Entwürfe von vor dieser Umstellung: TipTap hatte den Rahmen entfernt, übrig sind Kopfzeile + blockquote
const ALT_KOPF = /<p>\s*(Am [^<]{3,200}? schrieb |-{5,}\s*Weitergeleitete Nachricht)[\s\S]*$/;

export function splitZitat(html: string): { eigen: string; zitat: string } {
  const i = html.indexOf(QUOTE_DIV);
  if (i >= 0) return { eigen: html.slice(0, i), zitat: html.slice(i) };
  const m = ALT_KOPF.exec(html);
  if (m && m.index > 0)
    return { eigen: html.slice(0, m.index), zitat: `<div class="mm-quote">${m[0]}</div>` };
  return { eigen: html, zitat: '' };
}

// Nur zum Anzeigen im Entwurf: <style>-Blöcke raus (gelten sonst für die ganze App), fremde Bilder
// nicht laden (die Konversation blockt sie auch), Links nicht anklickbar machen übernimmt CSS.
export function zitatVorschau(zitat: string): string {
  return zitat
    .replace(/<style\b[\s\S]*?<\/style>/gi, '')
    .replace(/<img\b[^>]*>/gi, (img) => img.replace(/\ssrc="https?:[^"]*"/i, ''));
}
